export const FILMMAKER_CHANNELS = [
  {
    number: "401",
    name: "Scorsese",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Goodfellas", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "R", genres: ["Crime","Drama"], summary: "As far back as I can remember, I always wanted to be a gangster." },
      { title: "Raging Bull", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "R", genres: ["Drama","Sports"], summary: "Jake LaMotta. De Niro at his absolute best." },
    ],
  },
  {
    number: "402",
    name: "Spielberg",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Raiders of the Lost Ark", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "PG", genres: ["Adventure","Action"], summary: "Indy. The boulder. The ark. Cinema perfection." },
      { title: "Jaws", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "PG", genres: ["Thriller","Horror"], summary: "You're gonna need a bigger boat." },
      { title: "Spielberg Short Film Block", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "PG", genres: ["Drama"], summary: "Excerpts and extras from the Spielberg universe." },
    ],
  },
  {
    number: "403",
    name: "Tarantino",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Pulp Fiction", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "R", genres: ["Crime","Drama"], summary: "Royale with cheese. Ezekiel 25:17. The needle drop that defines QT." },
      { title: "Reservoir Dogs", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "R", genres: ["Crime","Thriller"], summary: "Are you gonna bark all day, little doggy, or are you gonna bite?" },
    ],
  },
  {
    number: "404",
    name: "Christopher Nolan",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Dark Knight", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "PG-13", genres: ["Action","Drama"], summary: "Why so serious? Heath Ledger. The greatest superhero film ever made." },
      { title: "Memento", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "R", genres: ["Thriller","Mystery"], summary: "Backwards. Tattoos. Leonard Shelby finding his wife's killer." },
    ],
  },
  {
    number: "405",
    name: "PT Anderson",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "There Will Be Blood", start: "8:00 PM", end: "10:45 PM", width: 6, rating: "R", genres: ["Drama","History"], summary: "I drink your milkshake. Daniel Plainview. An American epic." },
      { title: "Boogie Nights", start: "10:45 PM", end: "12:30 AM", width: 4, rating: "R", genres: ["Drama"], summary: "The adult film industry in the San Fernando Valley. Rollergirl. Dirk Diggler." },
    ],
  },
  {
    number: "406",
    name: "James Cameron",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Aliens", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "R", genres: ["Sci-Fi","Action","Horror"], summary: "Game over, man. Game over. The greatest action sequel ever made." },
      { title: "Terminator 2: Judgment Day", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "R", genres: ["Action","Sci-Fi"], summary: "Hasta la vista, baby. The greatest sequel ever made, period." },
    ],
  },
  {
    number: "407",
    name: "Leonardo DiCaprio",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1503455637927-730bce8583c0?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Departed", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "R", genres: ["Crime","Thriller"], summary: "I'm the guy who does his job. You must be the other guy." },
      { title: "The Wolf of Wall Street", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "R", genres: ["Comedy","Crime","Drama"], summary: "Did you just chuck a dwarf? Three hours of absolute chaos." },
    ],
  },
  {
    number: "408",
    name: "Tom Hanks",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Forrest Gump", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "PG-13", genres: ["Drama","Comedy"], summary: "Life is like a box of chocolates. Run, Forrest, run." },
      { title: "Cast Away", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "PG-13", genres: ["Drama","Adventure"], summary: "Wilson! Four years on an island. Hanks alone for most of it." },
    ],
  },
  {
    number: "409",
    name: "Denzel Washington",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Training Day", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Crime","Thriller"], summary: "King Kong ain't got nothing on me. The Oscar. The role." },
      { title: "Man on Fire", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "R", genres: ["Action","Thriller"], summary: "Creasy's art is death. He is about to paint his masterpiece." },
      { title: "American Gangster", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Crime","Drama"], summary: "First ten minutes of the Frank Lucas story." },
    ],
  },
  {
    number: "410",
    name: "Terence Winter",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Boardwalk Empire (Pilot)", start: "8:00 PM", end: "9:15 PM", width: 3, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Scorsese directed this pilot. Nucky Thompson. Atlantic City 1920." },
      { title: "Boardwalk Empire", start: "9:15 PM", end: "10:15 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "The empire building continues. Winter at his best." },
      { title: "The Sopranos (Winter-penned Episode)", start: "10:15 PM", end: "11:15 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "A Terence Winter Sopranos episode. He wrote the best ones." },
      { title: "The Wolf of Wall Street", start: "11:15 PM", end: "12:30 AM", width: 3, rating: "R", genres: ["Comedy","Crime"], summary: "Winter wrote this too. Scorsese + Winter = chaos." },
    ],
  },
  {
    number: "411",
    name: "David Chase",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Sopranos", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Tony Soprano at the ducks. The pilot. Where it all began." },
      { title: "The Sopranos", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "College — the pivotal episode. Tony and Meadow." },
      { title: "The Sopranos", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Pine Barrens. The greatest episode of television." },
      { title: "The Sopranos", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Made in America. The finale. Don't Stop Believin'." },
      { title: "Many Saints of Newark", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Crime","Drama"], summary: "The prequel film. Young Tony. The family origin." },
    ],
  },
  {
    number: "412",
    name: "David Simon",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Wire", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "The Pilot. D'Angelo explaining chess. Omar comin'." },
      { title: "The Wire", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "All the pieces matter. The best show ever made." },
      { title: "The Deuce", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Times Square in the 70s. Gritty and ambitious." },
      { title: "Treme", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-MA", genres: ["Drama","Music"], summary: "New Orleans post-Katrina. Simon's love letter to the city." },
      { title: "Generation Kill", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "TV-MA", genres: ["Drama","War"], summary: "Iraq. First recon. The beginning of the Simon-HBO run." },
    ],
  },
  {
    number: "413",
    name: "Vince Gilligan",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Breaking Bad", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Pilot. Walter White. The diagnosis. The transformation begins." },
      { title: "Breaking Bad", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Ozymandias — the greatest single episode of TV ever made." },
      { title: "Better Call Saul", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Jimmy McGill becoming Saul Goodman. It took six seasons." },
      { title: "Better Call Saul", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "The Gene chapters. Black and white. Full circle." },
      { title: "The X-Files (Gilligan Episodes)", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "TV-14", genres: ["Sci-Fi","Drama"], summary: "Vince Gilligan wrote some of the best X-Files episodes. Ice." },
    ],
  },
  {
    number: "414",
    name: "J.J. Abrams",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Lost (Pilot)", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "TV-14", genres: ["Drama","Mystery","Sci-Fi"], summary: "The greatest TV pilot ever made. The crash. The monster. The hatch." },
      { title: "Alias (Pilot)", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-14", genres: ["Action","Drama"], summary: "Sydney Bristow. Double agent. The red wig era." },
      { title: "Fringe (Pilot)", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-14", genres: ["Sci-Fi","Drama"], summary: "Fringe science. Walter Bishop. The alternate universe." },
      { title: "Super 8", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "PG-13", genres: ["Sci-Fi","Adventure"], summary: "Spielberg-produced, Abrams-directed 80s creature nostalgia." },
    ],
  },
  {
    number: "415",
    name: "Adam McKay",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1503455637927-730bce8583c0?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Big Short", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Comedy","Drama"], summary: "Do you know what CDOs are? Margot Robbie explains. McKay goes serious." },
      { title: "Anchorman", start: "10:00 PM", end: "11:30 PM", width: 3, rating: "PG-13", genres: ["Comedy"], summary: "I'm Ron Burgundy. San Diego. Milk was a bad choice." },
      { title: "Step Brothers", start: "11:30 PM", end: "12:30 AM", width: 2, rating: "R", genres: ["Comedy"], summary: "Did we just become best friends? YEP." },
    ],
  },
  {
    number: "416",
    name: "Ridley Scott",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Alien", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Sci-Fi","Horror"], summary: "In space no one can hear you scream. The original." },
      { title: "Blade Runner", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "R", genres: ["Sci-Fi","Noir"], summary: "The Final Cut. All those moments will be lost in time like tears in rain." },
      { title: "Gladiator", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Action","Drama"], summary: "Are you not entertained? The first act at midnight." },
    ],
  },
  {
    number: "417",
    name: "David Fincher",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Fight Club", start: "8:00 PM", end: "10:15 PM", width: 5, rating: "R", genres: ["Drama","Thriller"], summary: "The first rule of Fight Club. You do not talk about Fight Club." },
      { title: "Se7en", start: "10:15 PM", end: "12:15 AM", width: 4, rating: "R", genres: ["Crime","Thriller"], summary: "What's in the box? Mills and Somerset. The seven sins." },
      { title: "Zodiac", start: "12:15 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Crime","Thriller"], summary: "The opening of Fincher's most underrated film." },
    ],
  },
  {
    number: "418",
    name: "Coen Brothers",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "No Country for Old Men", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Crime","Thriller","Western"], summary: "Anton Chigurh. Coin flip. There are no clean getaways." },
      { title: "Fargo", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "R", genres: ["Crime","Comedy","Thriller"], summary: "Oh ya. Wood chipper. Marge Gunderson. Minnesota nice." },
      { title: "The Big Lebowski", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Comedy","Crime"], summary: "The Dude abides. First act at midnight." },
    ],
  },
  {
    number: "419",
    name: "Tim Burton",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Edward Scissorhands", start: "8:00 PM", end: "9:45 PM", width: 4, rating: "PG-13", genres: ["Fantasy","Drama","Romance"], summary: "An unfinished man with scissors for hands. Burton's purest film." },
      { title: "Beetlejuice", start: "9:45 PM", end: "11:15 PM", width: 3, rating: "PG", genres: ["Comedy","Horror","Fantasy"], summary: "Say his name three times. Michael Keaton unhinged." },
      { title: "Batman", start: "11:15 PM", end: "12:30 AM", width: 3, rating: "PG-13", genres: ["Action","Fantasy"], summary: "Have you ever danced with the devil in the pale moonlight?" },
    ],
  },
  {
    number: "420",
    name: "Robert Zemeckis",
    category: "FILMMAKER",
    preview: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Back to the Future", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "PG", genres: ["Sci-Fi","Comedy","Adventure"], summary: "Roads? Where we're going we don't need roads. The perfect movie." },
      { title: "Back to the Future Part II", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "PG", genres: ["Sci-Fi","Comedy","Adventure"], summary: "2015 had hoverboards and flying cars. We got half of one." },
      { title: "Who Framed Roger Rabbit", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "PG", genres: ["Comedy","Mystery","Animation"], summary: "Toons and humans. The first act at midnight." },
    ],
  },
];
